export default __webpack_public_path__ + "static/media/elevate-bpn-poster-3.8edae060.jpg";